import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WebflowSignUpPage } from './webflow-signup.page';

const routes: Routes = [
  {
    path: '',
    component: WebflowSignUpPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WebflowSignupPageRoutingModule {}
